<script>
    /** Título del estado vacío. */
    export let message = 'Sin resultados'
    /** Texto secundario opcional. */
    export let subtitle = ''
    /** Icono Font Awesome (sin prefijo `fa-`). */
    export let icon = 'inbox'
    /** Muestra el bloque cuando es true. */
    export let show = false
    /** Menos altura vertical (listas o paneles compactos). */
    export let compact = false
</script>

{#if message && show}
    <div
        class="til-empty"
        class:til-empty--compact={compact}
        role="status"
        aria-live="polite"
    >
        <div class="til-empty__icon" aria-hidden="true">
            <i class="fas fa-{icon}"></i>
        </div>
        <p class="til-empty__title">{message}</p>
        {#if subtitle}
            <p class="til-empty__subtitle">{subtitle}</p>
        {/if}
    </div>
{/if}

<style>
    .til-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 5rem;
        padding: 2.5rem 1.5rem;
        text-align: center;
        animation: til-empty-enter 0.2s ease-out;
    }

    .til-empty--compact {
        min-height: 2.75rem;
        padding: 1.5rem 1rem;
    }

    .til-empty--compact .til-empty__icon {
        width: 2.75rem;
        height: 2.75rem;
        margin-bottom: 0.75rem;
        font-size: 1rem;
    }

    .til-empty--compact .til-empty__title {
        font-size: 0.9375rem;
    }

    .til-empty__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3.5rem;
        height: 3.5rem;
        margin-bottom: 1rem;
        border-radius: 50%;
        background: var(--til-accent-soft);
        color: var(--til-accent);
        font-size: 1.25rem;
    }

    .til-empty__title {
        margin: 0 0 0.25rem;
        color: var(--til-ink);
        font-size: 1rem;
        font-weight: 600;
        line-height: 1.35;
    }

    .til-empty__subtitle {
        margin: 0;
        max-width: 22rem;
        color: var(--til-muted);
        font-size: 0.875rem;
        line-height: 1.45;
    }

    @keyframes til-empty-enter {
        from {
            opacity: 0;
            transform: translateY(4px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>
